<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="未完成任务" name="toPro">
        <to-pro-list ref="toProList" @tabChange="tabChange($event, '0')">
          <!-- <template slot="toolbar-right">
            <el-button type="primary" @click="openEdit">批量报工</el-button>
          </template> -->
        </to-pro-list>
      </el-tab-pane>
      <el-tab-pane label="已完成任务" name="proLog">
        <pro-log-list ref="proLogList" @tabChange="tabChange($event, '1')">
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="160">
              <template slot-scope="{ row }">
                <el-button v-if="$permission.canWrite()" type="text" @click="undo(row)">撤销</el-button>
              </template>
            </el-table-column>
          </template>
        </pro-log-list>
      </el-tab-pane>
    </el-tabs>
    <report-dialog ref="editDialog" @saved="handleClick" :displayMode="displayMode0"></report-dialog>
    <already-report-dialog ref="alreadyReportDialog" @saved="handleClick" :displayMode="displayMode1"></already-report-dialog>
  </div>
</template>
<script>
import curdMixins from '@/mixins/trend/curd'
import toProList from '@/components/production/reportmanagement/report/toPro/list'
import reportDialog from '@/components/production/reportmanagement/report/toPro/reportDialog'
import proLogList from '@/components/production/reportmanagement/report/proLog/list'
import alreadyReportDialog from '@/components/production/reportmanagement/report/proLog/alreadyReportDialog'

export default {
  name: 'workreport',
  mixins: [curdMixins],
  components: {
    toProList,
    proLogList,
    reportDialog,
    alreadyReportDialog
  },
  data() {
    return {
      tabName: 'toPro',
      displayMode0: 1,
      displayMode1: 1,
      api: require('@/api/pu/report').default
    }
  },
  methods: {
    undo(row) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api
        .cancel({ workDocId: row.WorkDocId ,planDtsId:row.PlanDtsId})
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$refs.proLogList.reload()
            this.$message.success(res.Msg)
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    // edit(row) {
    //   this.$refs.toProList.edit(row);
    // },
    openEdit() {
      const checkList = this.$refs.toProList.checkList
      if (checkList.length > 0) {
        this.edit({ checkList: checkList, batch: true })
      } else {
        this.$message.error('请勾选列表中的数据！')
      }
    },
    details(id) {
      this.$refs.proLogList.details(id)
    },
    handleClick() {
      this.reload()
    },
    reload() {
      this.$refs[this.tabName + 'List'].reload()
      this.$nextTick(() => {
        this.$refs[this.tabName + 'List'].$refs.list.$refs.table.doLayout()
      })
    },
    openDialog() {
      // this.$refs.alreadyReportDialog.open()
      const checkList = this.$refs.proLogList.checkList
      if (checkList.length == 1) {
        this.$refs.alreadyReportDialog.openEdit({ checkList: checkList })
      } else {
        this.$message.error('请勾选列表中的一条数据！')
      }
    },
    tabChange(val, type) {
      if (val == '0') this['displayMode' + type] = 1
      if (val == '1') this['displayMode' + type] = 2
      if (val == '2') this['displayMode' + type] = 2
      if (val == '3') this['displayMode' + type] = 2
      if (val == '4') this['displayMode' + type] = 2
    }
  }
}
</script>